import type { DisciplineType } from '../services/api/models/DisciplineType';

/**
 * Get Tailwind CSS classes for discipline badge styling based on discipline type
 * @param disciplineName - The discipline type (SN, PT, OT, ST, MSW, HHA)
 * @returns Tailwind CSS class string for badge styling
 */
export const getDisciplineColor = (disciplineName: DisciplineType): string => {
  const colorMap: Record<DisciplineType, string> = {
    SN: 'bg-blue-100 text-blue-800 border-blue-200',
    PT: 'bg-teal-100 text-teal-800 border-teal-200',
    OT: 'bg-orange-100 text-orange-800 border-orange-200',
    ST: 'bg-purple-100 text-purple-800 border-purple-200',
    MSW: 'bg-rose-100 text-rose-800 border-rose-200',
    HHA: 'bg-green-100 text-green-800 border-green-200',
  };
  return (
    colorMap[disciplineName] || 'bg-gray-100 text-gray-800 border-gray-200'
  );
};
